// External
import styled, { css } from "styled-components";
import { safeWindow } from "../../utils/helpers/ssr";
import { Element } from "react-scroll";
import { sectionRhythm } from "../../styles/section-rhythm";

const padY = (props, size) => {
  const value = sectionRhythm.paddingY[size];
  const top = props.$flushTop || props.fullscreen ? 0 : value;
  const headerExtra = props.$compensateHeaderGap
    ? sectionRhythm.headerHeight[size]
    : 0;
  const bottom = props.$flushBottom ? 0 : value + headerExtra;
  return css`
    padding-block: ${top}px ${bottom}px;
  `;
};

/**
 * Shared page-section primitive.
 * Half-gap vertical padding so abutting sections sum to sectionRhythm.gap.
 */
export const PageSection = styled(Element)`
  ${(props) => padY(props, "mobile")}
  background-color: ${(props) =>
    props.$bgColor || props.bgColor || "transparent"};
  box-sizing: border-box;

  @media only screen and (min-width: ${sectionRhythm.breakpoint}) {
    ${(props) => padY(props, "desktop")}
  }

  ${(props) =>
    props.fullscreen &&
    css`
      position: relative;
      min-height: calc(
        ${safeWindow.innerHeight ? `${safeWindow.innerHeight}px` : "95vh"} -
          80px
      );
    `}
`;

/** @deprecated Prefer PageSection - kept as alias for gradual migration */
export const Section = PageSection;
